import "./productStyle.css";
import ProductPic from "../../../img/smaPicCart.png";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/smallProductLike.svg";
import iconSrcCard from "../../../svg/smallProductCard.svg";
import { useState, useEffect } from "react";
import addToCart from "../../../function/addToCard";
import { Link } from "react-router-dom";
import transliterate from "../../../function/transliterate";
import { PhotoProvider, PhotoSlider, PhotoView } from "react-photo-view";
import { findAuthorByName } from "../../mainPage/getAuthorLink";
import { getProductHref } from "../../../function/productLink";

export default function SmallProductCart({
  el,
  setCartCounterC,
  setLikeCounterC,
}) {
  const [liked, setLiked] = useState(false);
  const [authorLinkData, setAuthorLinkData] = useState(null);
  const [picWriterLinkData, setPicWriterLinkData] = useState(null);
  useEffect(() => {
    const fetchPicWriter = async () => {
      const result = await findAuthorByName(el?.picWriter);
      setPicWriterLinkData(result);
    };
    if (el?.picWriter) {
      fetchPicWriter();
    }
  }, [el?.picWriter]);

  useEffect(() => {
    const fetchAuthor = async () => {
      const result = await findAuthorByName(el?.textAutor);
      setAuthorLinkData(result);
    };
    if (el?.textAutor) {
      fetchAuthor();
    }
  }, [el?.textAutor]);
  useEffect(() => {
    const likedProducts =
      JSON.parse(localStorage.getItem("likedProducts")) || [];

    const isLiked = likedProducts.some((product) => product.uid === el.uid);

    setLiked(isLiked);
  }, []);
  const handleLike = () => {
    let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];

    if (!liked) {
      setLikeCounterC((prev) => prev + 1);
      likedProducts.push(el);
    } else {
      setLikeCounterC((prev) => prev + 1);
      const updatedLikedProducts = likedProducts.filter(
        (product) => product.uid !== el.uid,
      );
      likedProducts = updatedLikedProducts;
    }

    localStorage.setItem("likedProducts", JSON.stringify(likedProducts));

    setLiked(!liked);
  };
  const addingToCart = (id) => {
    addToCart(id);

    setCartCounterC((prev) => prev + 1);
  };
  console.log("el", el);

  return (
    <div className="smallProductWrap">
      {el && (
        <>
          {/* <img src={el.imageList[0]} className="productPicSmall" /> */}
          <PhotoProvider>
            <PhotoView src={el.imageList[0]}>
              <img
                src={el.imageList[0]}
                alt={`${el.bookName}`}
                className="productPicSmall"
              />
            </PhotoView>
            {/* Додаємо всі зображення до PhotoView для перегляду в повноекранному режимі */}
            {el.imageList.map((item, index) => (
              <PhotoView key={index} src={item}>
                <span style={{ display: "none" }} />
              </PhotoView>
            ))}
          </PhotoProvider>
          <div className="prodPricLikeCart">
            {/* <div className="prdeProdPricingCart">
              <div className="prdeProdPricingRotateCart">
                <p className="fullPriceCartNewR">{el.priceSale}</p>
                <p className="salePriceCart">{el.price}</p>
                <p className="fullPriceCartG">грн</p>
              </div>
            </div> */}
            <div className="prdeProdPricingCart">
              <div className="prdeProdPricingRotateCart">
                {el.priceSale ? (
                  <>
                    <p className="fullPriceCartNewR">{el.priceSale}</p>
                    <p className="salePriceCart">{el.price}</p>
                    <p className="fullPriceCartG">грн</p>
                  </>
                ) : el.actionDiscountPercent ? (
                  <>
                    <p className="fullPriceCartNewR">{el.price}</p>
                    <p className="salePriceCart">
                      {Math.round(
                        el.price - (el.price * el.actionDiscountPercent) / 100,
                      )}
                    </p>
                    <p className="fullPriceCartG">грн</p>
                  </>
                ) : (
                  <>
                    <p className="salePriceCart">{el.price}</p>
                    <p className="fullPriceCartG">грн</p>
                  </>
                )}
              </div>
            </div>
            <div className="likeCardWrapSmall">
              <div
                className={`likeProductSmall${liked ? "Click" : ""}`}
                onClick={handleLike}
              >
                <HandySvg src={iconSrc} width="34" height="31" />
              </div>
              <div
                className="likeProductSmall"
                onClick={() => addingToCart(el.uid)}
              >
                <HandySvg src={iconSrcCard} width="28.33" height="28.33" />
              </div>
            </div>
          </div>

          <Link className="smallProdName" to={getProductHref(el)}>
            {el.bookName}
          </Link>

          <div className="autorInformCart">
            <div className="autorInformSectionCart">
              <p>Автор:&nbsp;</p>
              {authorLinkData ? (
                <Link
                  className="autorInformSectionCartNdm"
                  to={`/author/${authorLinkData.uid}`}
                >
                  {el.textAutor}
                </Link>
              ) : (
                <h4>{el.textAutor}</h4>
              )}
            </div>
            <div className="autorInformSectionCart">
              <p>Художник:&nbsp;</p>
              {picWriterLinkData ? (
                <Link
                  className="autorInformSectionCartNdm"
                  to={`/author/${picWriterLinkData.uid}`}
                >
                  {el.picWriter}
                </Link>
              ) : (
                <h4>{el.picWriter}</h4>
              )}
            </div>
          </div>
          <Link to={getProductHref(el)} className="descriptionBooksCart">
            {el.smallDesc}
          </Link>
        </>
      )}
    </div>
  );
}
